import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    headerContainer: {
      marginHorizontal: 24,
    },
    contentContainer: {
      flex: 1,
      paddingHorizontal: 24,
    },
    listItemContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 24,
    },
    nameContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    optionIcon: {
      marginHorizontal: 10,
      paddingVertical: 10,
    },
    buttonContainer: {
    },
    menuOptionsContainer: {
      borderRadius: 16,
      paddingHorizontal: 16,
      // react-native-popup-menu defaults to a white sheet; theme it so the
      // menu is legible in dark (light stays #fff — pixel-identical).
      backgroundColor: colors.surfaceElevated,
    },
    noContactsListContainer: {
      ...CommonStyles.full_flex,
      ...CommonStyles.flex_center,
    },
    emptyContacts: {
      display: 'flex',
      flexDirection: 'column',
      ...CommonStyles.items_center,
    },
    line: {
      border: `1px solid ${colors.border}`,
      width: '100%',
    },
    listItem: {
      display: 'flex',
      gap: '17px',
      marginLeft: '24px',
      marginBottom: '32px',
    },
    listText: {
      display: 'grid',
      gap: '5px',
    },
    listActions: {
      display: 'flex',
      gap: '8px',
    },
    webButtonContainer: {
      ...CommonStyles.mb_16,
      ...CommonStyles.mh_24,
    },
  });

export default makeStyles;
